// API Configuration
// This file centralizes the base URL configuration for all API calls

import axios from 'axios'

// Get the API base URL from environment variables
// In development: http://localhost:8000
// In production: https://your-backend-domain.com
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000'

// Every request gets a bounded wait (issue #407). Axios defaults to 0 = forever,
// so a hung connection left list spinners up until a reload. Set here because every
// service module imports this file; a shared axios.create() instance would break the
// `jest.mock('axios')` pattern the service tests rely on.
export const REQUEST_TIMEOUT_MS = 30000
// For the few synchronous endpoints that legitimately run long; matches gunicorn's
// --timeout 120 (backend/Dockerfile), past which the server kills the worker anyway.
export const LONG_REQUEST_TIMEOUT_MS = 120000
axios.defaults.timeout = REQUEST_TIMEOUT_MS

// Helper function to create full URL for API endpoints
export const createApiUrl = (endpoint) => {
  // Remove leading slash if present to avoid double slashes
  const cleanEndpoint = endpoint.startsWith('/') ? endpoint.slice(1) : endpoint
  return `${API_BASE_URL}/${cleanEndpoint}`
}

export default API_BASE_URL
